import { Injectable } from '@angular/core';
import { MedicalConditionModel } from '../../../models/master-data/medical-condition.model';
import { BaseService } from '../../../shared/services/base.service';
import { MedicalConditionCategoryUrl } from '../../../shared/urls/master-data.medical-condition-category.urls';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { MedicalConditionUrl } from '../../../shared/urls/master-data.medical-condition.urls';
@Injectable()
export class CentreManagementFeeService {
    constructor(public baseService: BaseService) {
    }
    getAllCentre(param) {
      const url = MasterDataUrl.GET_ALL_CENTRE;
      return this.baseService.getData(url, param);
    }

    getCentreManagementFees(id) {
        const url = MasterDataUrl.GET_CENTRE_MANAGEMENT_FEES_BY_CENTREID.replace('{id}', id);
        return this.baseService.getData(url);
    }

    getCentreManagementFee(id) {
      const url = MasterDataUrl.GET_CENTRE_MANAGEMENT_FEE_BY_ID.replace('{id}', id);
      return this.baseService.getData(url);
    }

    updateCentreManagementFee(id, param) {
        const url = MasterDataUrl.UPDATE_CENTRE_MANAGEMENT_FEE.replace('{id}', id);
        return this.baseService.update(url, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/centre-management-fees/centre-management-fees.service.ts